module.exports = __webpack_public_path__ + "img/web3icon11.3f46fe28.png";